/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Suspense } from 'react'

import { PortfolioLoading } from './loading'
import { PortfolioContainer } from './portfolio-container'

// empty react component
export const PortfolioPage: React.FC = (): JSX.Element => {
  return (
    <Suspense fallback={<PortfolioLoading />}>
      <PortfolioContainer />
    </Suspense>
  )
}
